export enum PeriodUnit {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

export interface Period {
  unit: PeriodUnit;
  quantity: number;
}

export type SimpleTimeUnits = {
  d: string;
  h: string;
  m: string;
  s?: string;
};

export enum TimeUnitWord {
  Recent = 'recent',
  Second = 'second',
  Minute = 'minute',
  Hour = 'hour',
  Day = 'day',
  Year = 'year',
}
